<div class="row activity-filters" (clickOutside)="onClickedOutside($event)" (exclude)="'.single-selected'">
  <div class="col-md-12 slider-container">
    <achoo-slider #reachRangeSlider [name]="'reach'"
                  [min]="minReach" [max]="maxReach"
                  [from]="reachFrom" [to]="reachTo"
                  [label]="'Reach'"
                  [(model)]="activitySearchCriteria.selectedReach"></achoo-slider>
  </div>
  <div class="col-md-12 slider-container" *ngIf="!isActiveDiscoverFollower">
    <achoo-slider #engagementRangeSlider [name]="'engagement'"
                  [min]="minEngagement" [max]="maxEngagement"
                  [from]="engagementFrom" [to]="engagementTo"
                  [label]="'discover.search_bar.engagement' | translate"
                  [(model)]="activitySearchCriteria.selectedEngagement"
                  [overMaxValue]="true"></achoo-slider>
  </div>
  <div class="col-md-12 slider-container" *ngIf="isActiveDiscoverFollower">
    <achoo-slider #followerRangeSlider [name]="'follower'"
                  [min]="minFollower" [max]="maxFollower"
                  [from]="followerFrom" [to]="followerTo"
                  [label]="'discover.search_bar.follower' | translate"
                  [(model)]="activitySearchCriteria.selectedFollower"
                  [overMaxValue]="followerTo === maxFollower"></achoo-slider>
  </div>
  <div class="col-md-12 slider-container">
    <achoo-slider #impactRangeSlider [name]="'impact'"
                  [min]="minImpact" [max]="maxImpact"
                  [from]="impactFrom" [to]="impactTo"
                  [label]="'Impact'"
                  [dataType]="'percent'"
                  [(model)]="activitySearchCriteria.selectedImpact"
                  [overMaxValue]="isActiveDiscoverFollower && (maxImpact === impactTo)"></achoo-slider>
  </div>
  <div class="col-md-12">
    <div class="activity-filter-seperator"></div>
  </div>
  <div class="col-md-12 d-flex flex-row slider-container button-group">
    <button class="button gray" (click)="resetActivityFilters()">{{'common.btn.reset' | translate}}</button>
    <div class="d-flex flex-auto"></div>
    <button class="button blue" (click)="searchInfluencerByActivity()">{{'common.btn.save' | translate}}</button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/search-bar/activity-filters/activity-filters.component.html